import(/* webpackMode: "eager", webpackExports: ["DynamicAutoLogin"] */ "/home/runner/work/settlin.in/settlin.in/components/homepage/lazy-client-components.tsx");
